import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import moment from 'moment';

import firebase from 'firebase/app';
require("firebase/firestore");
require("firebase/functions");

class TestPage extends Component {
  state = {
    id: '',
    collection: '',
    userId: 'zxra1DgkETQr8Vucxp4dF36wx8D3',
    message: '',
  };

  go = () => {
    if (this.state.id && this.state.collection) {
      firebase.firestore()
        .collection(this.state.collection)
        .doc(this.state.id)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.setState({ message: "exists" });
          }
        })
        .catch(error => {
          this.setState({ message: "error" });
        });
    }
  }

  delete = () => {
    if (this.state.id && this.state.collection) {
      firebase.firestore()
        .collection(this.state.collection)
        .doc(this.state.id)
        .delete()
        .then(() => {
          this.setState({ message: "Document successfully deleted!" });
        })
        .catch(error => {
          this.setState({ message: "error" });
        });
    }
  }

  getUserPasses = (userId) => {
    console.log(userId);

    return firebase.firestore()
      .collection('userPasses')
      .where("userId", "==", userId)
      .get()
      .then(qs => {
        console.log(qs.size);
        qs.forEach(doc => {
          console.log(doc.id);
        });
      });
  }

  getUserPassTransactions = (userId) => {
    console.log(userId);
    
    return firebase.firestore()
      .collection('passTransaction')
      .where("userId", "==", userId)
      .get()
      .then(qs => {
        console.log(qs.size);
        qs.forEach(doc => {
          console.log(doc.id);
        });
      });
  }

  clearUser = (userId) => {
    if (!userId) {
      return Promise.resolve();
    }

    return firebase.firestore()
      .collection('users')
      .doc(userId)
      .get()
      .then(doc => {
        if (doc.exists) {
          console.log(userId + " exists");
          return Promise.all([
            this.clearUserData(userId, 'deskTransaction'),
            this.clearUserData(userId, 'passTransaction'),
            this.clearUserData(userId, 'userPassAdjustRecords'),
            this.clearUserData(userId, 'userPasses'),
          ]);
        } else {
          console.log(userId + " not exists");
          return Promise.resolve();
        }
      });
  }

  clearUserData = (userId, collectionName) => {
    let ref = firebase.firestore().collection(collectionName);
    return ref
      .where("userId", "==", userId)
      .get()
      .then(qs => {
        let promises = [];
        qs.forEach(doc => {
          promises.push(ref.doc(doc.id).delete().then(() => {
            console.log(collectionName + " - DELETED : " + doc.id);
            return Promise.resolve();
          }));
        });
        return Promise.all(promises);
      });
  }

  getUserIsFirstCome = (userId, date) => {
    return firebase.firestore()
      .collection('deskTransaction')
      .where("userId", "==", userId)
      .where('checkInTime', '<', date)
      .orderBy("checkInTime", "desc")
      .get()
      .then(qs => qs.size === 0);
  }

  test = () => {
    return firebase.functions().httpsCallable('test')()
      .catch(err => {
        console.error(err);
      });
  }

  test3 = () => {
    var from = moment().set({ year: 2018, month: 9 }).startOf('month');
    var to = moment().set({ year: 2018, month: 10 }).endOf('month');

    return firebase.firestore()
      .collection('deskTransaction')
      .where('checkInTime', '>=', from.toDate())
      .where('checkInTime', '<=', to.toDate())
      .get()
      .then(qs => {
        var count = 0;

        qs.forEach(doc => {
          let deskTransaction = doc.data();
          if (
            deskTransaction.isFirstCome === undefined &&
            deskTransaction.userId &&
            deskTransaction.checkInTime) {

            count++;
            // console.log(`${doc.id}`);

            firebase.firestore()
              .collection('deskTransaction')
              .doc(doc.id)
              .update({
                test: true,
              });
          }
        });

        console.log(count);
      });
  }

  // test2 = () => {
    // firebase.firestore()
    //   .collection('users')
    //   .get()
    //   .then(qsUsers => {
    //     qsUsers.forEach(userDoc => {
    //       console.log("user: " + userDoc.id);
    //
    //       firebase.firestore()
    //         .collection('users')
    //         .doc(userDoc.id)
    //         .collection('passes')
    //         .get()
    //         .then(qs => {
    //           qs.forEach(doc => {
    //             // console.log(doc.id);
    //
    //             let data = doc.data();
    //             data.passId = doc.id;
    //             data.userId = userDoc.id;
    //
    //             firebase.firestore()
    //               .collection('userPasses')
    //               .add(data)
    //               .then(() => console.log(doc.id + " OK"));
    //           });
    //         });
    //     });
    //   });
  // }

  render() {
    return (
      <div>
        <div>
          <TextField
            style={{ marginRight: 16 }}
            label="collection"
            value={this.state.collection}
            onChange={event => this.setState({ collection: event.target.value })}
            margin="normal"
          />
          <TextField
            style={{ marginRight: 16 }}
            label="id"
            value={this.state.id}
            onChange={event => this.setState({ id: event.target.value })}
            margin="normal"
          />
        </div>
        <div>
          <Button variant="contained" style={{ marginRight: 16 }} onClick={this.go}>GO</Button>
          <Button variant="contained" style={{ marginRight: 16 }} onClick={this.delete}>DELETE</Button>
        </div>
        {/* User */}
        <div>
          <TextField
            label="userId"
            value={this.state.userId}
            onChange={event => this.setState({ userId: event.target.value })}
            margin="normal"
          />
        </div>
        <div>
          <Button variant="contained" style={{ marginRight: 16 }} onClick={() => this.getUserPasses(this.state.userId)}>USER PASSES</Button>
          <Button variant="contained" style={{ marginRight: 16 }} onClick={() => this.getUserPassTransactions(this.state.userId)}>PASS TRANSACTIONS</Button>
          <Button variant="contained" style={{ marginRight: 16 }} onClick={() => this.clearUser(this.state.userId)}>CLEAR USER</Button>
        </div>
        {/* Test */}
        <br/>
        <div>
          <Button variant="contained" style={{ marginRight: 16 }} onClick={this.test}>TEST</Button>
          <Button variant="contained" style={{ marginRight: 16 }} onClick={this.test2}>TEST2</Button>
        </div>
        <Typography>
          {this.state.message}
        </Typography>
      </div>
    );
  }

}

export default TestPage;
